import { useCallback } from "react";

import __ from "web/Layout/Translations";

import Button from "web/Components/Common/ButtonCC";
import CodeModal from "web/Components/Common/CodeItem/CodeModal";
import modalOverrides from "web/Components/Common/CodeItem/CodeModal/codeModalModalOverrides.scss";

import { ModalActionTypes } from "web/hooks/useModal/useModalTypes";

import { ProductCodeFrontendStatus } from "web/types/Code";

import { useAppContext } from "web/context/app";

import classes from "./orderSummaryShowCode.scss";

interface ISuccessOrderSummaryShowCodeProps {
  name: string;
  itemId: number;
  isCanceled: boolean;
  htmlDataKey: string;
  orderPaid: boolean;
  sku: string;
  product_expiration_date?: string;
  userUsedDate?: string;
  userUsed?: boolean | number;
  productCodeFrontendStatus?: ProductCodeFrontendStatus;
}

function SuccessOrderSummaryShowCode({
  name,
  itemId,
  isCanceled,
  htmlDataKey,
  orderPaid,
  sku,
  product_expiration_date = "",
  userUsedDate = "",
  userUsed = 0,
  productCodeFrontendStatus = "" as ProductCodeFrontendStatus,
}: ISuccessOrderSummaryShowCodeProps) {
  const { modal, isMobile } = useAppContext();
  const { dispatch } = modal;

  const showModal = useCallback(() => {
    dispatch({
      type: ModalActionTypes.ADD_MODAL,
      modal: isCanceled ? null : (
        <CodeModal
          productName={name}
          itemId={itemId}
          orderPaid={orderPaid}
          sku={sku}
          product_expiration_date={product_expiration_date}
          userUsedDate={userUsedDate}
          userUsed={userUsed}
          productCodeFrontendStatus={productCodeFrontendStatus}
        />
      ),
      ariaLabel: __("Twój kod"),
      hideCloseButton: true,
      classes: { content: modalOverrides.content },
    });
  }, [
    dispatch,
    name,
    itemId,
    isCanceled,
    orderPaid,
    sku,
    product_expiration_date,
    userUsedDate,
    userUsed,
    productCodeFrontendStatus,
  ]);

  return (
    <Button
      onClick={showModal}
      dataT1={`${htmlDataKey}_show_code_button`}
      disabled={isCanceled}
      variant={isMobile ? "primary" : "secondary"}
      className={isMobile ? classes.mobileButton : ""}
    >
      {isCanceled ? __("Kod anulowany") : __("Wyświetl kod")}
    </Button>
  );
}

export default SuccessOrderSummaryShowCode;
